import { render, staticRenderFns } from "./register.vue?vue&type=template&id=7bccd1a3&"
import script from "./register.vue?vue&type=script&lang=ts&"
export * from "./register.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ThemeToggle: require('/home/forge/gradlinc-employer.co.za/releases/20250626124644/components/global/ThemeToggle.vue').default,TertiaryButton: require('/home/forge/gradlinc-employer.co.za/releases/20250626124644/components/buttons/TertiaryButton.vue').default})
